module.exports = __webpack_public_path__ + "project2-header.svg?d2f465deb6867dfda489220678c2c339";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/project2-header.svg
// module id = 349
// module chunks = 0